import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../components/Home"
import Cart from "../components/Cart"
import About from "../components/About"
import Mk from "../components/Mk"
import Login from "../components/Login"
// import Logout from "../components/Logout"
import NotFound from "../components/NotFound.vue"
import EmailConfirmation from "../components/EmailConfirmation"
import PasswordReset from "../components/PasswordReset"
import PasswordRestore from "../components/PasswordRestore"
import AfterRegistration from "../components/AfterRegistration"
import AfterPasswordReset from "../components/AfterPasswordReset"
import AfterPurchase from "../components/AfterPurchase"
import Agreement from "../components/Agreement"
import Privacy from "../components/Privacy"
import WellKnown from "../components/WellKnown"
import PaymentTest from "../components/PaymentTest"
import Blog from "../components/Blog.vue"
import Post from "../components/Post.vue"
import Register from "../components/Register"
import VuelidateTest from "../components/VuelidateTest"
// import PairStats from "../components/PairStats"
import store from '../store/index.js'

Vue.use(VueRouter);

const router = new VueRouter({
    routes: [

        {
            path: "",
            name: "home",
            component: Home,
            meta: { requiresAuth: false }
        },
        {
            path: "/about",
            name: "about",
            component: About,
            meta: { requiresAuth: false }
        },
        {
            path: "/mk",
            name: "mk",
            component: Mk,
            meta: {
                requiresAuth: true
            }
        },
        // :NEW
        // {
        //     path: "/pair_stats",
        //     name: "pair_stats",
        //     component: PairStats,
        //     meta: {
        //         requiresAuth: true
        //     }
        // },
        {
            // TODO: Think about validation of uid and token 
            // beforeEnter(from) {
            //     console.log("Here bitch")
            //     console.log(this);
            // },
            path: "/email-confirmation/:uid/:token",
            name: "email-confirmation",
            component: EmailConfirmation,
            meta: { requiresAuth: false }
        },
        {
            path: "/password-restore",
            name: "password-restore",
            component: PasswordRestore,
            meta: { requiresAuth: false }
        },
        {
            path: "/password-reset/:uid/:token",
            name: "password-reset",
            component: PasswordReset,
            meta: { requiresAuth: false }
        },
        {
            path: "/login",
            name: "login",
            component: Login,
            meta: { requiresAuth: false }
        },
        {
            path: "/.well-known",
            name: "well-known",
            component: WellKnown,
            meta: { requiresAuth: false }
        },
        {
            path: "/test_payment",
            name: "payment",
            component: PaymentTest,
            meta: { requiresAuth: true }
        },
        // {
        //     path: "/logout",
        //     name: "logout",
        //     component: Logout,
        //     meta: { requiresAuth: true }
        // },
        {
            path: "/register",
            name: "register",
            component: Register,
            meta: { requiresAuth: false }
        },
        {
            path: "/test",
            name: "test",
            component: VuelidateTest
        },
        {
            path: "/after_register",
            name: "after_register",
            component: AfterRegistration,
            meta: { requiresAuth: false }
        },

        {
            path: "/after_purchase",
            name: "after_purchase",
            component: AfterPurchase,
            meta: { requiresAuth: true }
        },
        {
            path: "/after_password_reset",
            name: "after_password_reset",
            component: AfterPasswordReset,
            meta: { requiresAuth: false }
        },
        {
            path: "/posts",
            name: "posts",
            component: Blog,
            meta: { requiresAuth: false }
        },
        {
            path: "/posts/:post_id",
            name: "post",
            component: Post,
            meta: { requiresAuth: false }
        },
        {
            path: "/cart",
            name: "cart",
            component: Cart,
            meta: { requiresAuth: false }
        },
        {
            path: "/agreement",
            name: "agreement",
            component: Agreement,
            meta: { requiresAuth: false }
        },
        {
            path: "/privacy",
            name: "privacy",
            component: Privacy,
            meta: { requiresAuth: false }
        },
        {
            path: "*",
            name: "404",
            component: NotFound,
            meta: { requiresAuth: false }
        }
    ],
    mode: "history",
    base: ""
})

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        console.log(store.getters.isLoggedIn)
        if (!store.getters.isLoggedIn) {
            console.log("this page requires login")
            next('/login')
        } else {
            next()
        }
    } else {
        console.log("this page is open")
        next()
    }
})

export default router